// cool animation showing a stylized 3d avatar using animation of svg paths

import React from "react";
import { Spinner } from '../../design-system/primitives/spinner';
const spacesCalc = (n: number) => Array(n).fill("\u00A0").join("");
const spaces = spacesCalc(10);
interface LoadingAnimationProps {
  messages: string[];
}
export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  messages,
}) => {
    const [messageIndex, setMessageIndex] = React.useState(0);
    const [message, setMessage] = React.useState(messages[0]);
    React.useEffect(() => {
      const interval = setInterval(() => {
        setMessageIndex((messageIndex + 1) % messages.length);
        setMessage(messages[messageIndex]);
      }, 1000 *3 );
      return () => clearInterval(interval);
    }, [messageIndex]);  
  return (
    <div className="flex items-center justify-center gap-4 p-6 text-center">
      <span className="overflow-hidden text-lg text-foreground-soft">{message}</span>
      <Spinner size={28} />
    </div>

  );
}
   